"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ErpAPI = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _NextApiClient = require("./NextApiClient");
var ErpAPI = /*#__PURE__*/function () {
  function ErpAPI() {
    (0, _classCallCheck2["default"])(this, ErpAPI);
  }
  (0, _createClass2["default"])(ErpAPI, null, [{
    key: "loadAdmTable",
    value: function loadAdmTable(table, _ref) {
      var orderBy = _ref.orderBy,
        ascending = _ref.ascending,
        page = _ref.page,
        limit = _ref.limit,
        query = _ref.query,
        byColumn = _ref.byColumn,
        cWhere = _ref.cWhere;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        table: table,
        orderBy: orderBy,
        ascending: ascending,
        page: page,
        limit: limit,
        query: query,
        byColumn: byColumn,
        cWhere: cWhere
      };
      _NextApiClient.NextApiClient.com(this.service, 'jLoadAdmTabDt', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "changeUserADAL",
    value: function changeUserADAL(_ref2) {
      var userId = _ref2.userId,
        upn = _ref2.upn,
        lastName = _ref2.lastName,
        firstName = _ref2.firstName,
        group = _ref2.group,
        modules = _ref2.modules,
        shops = _ref2.shops,
        language = _ref2.language,
        active = _ref2.active,
        email = _ref2.email;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
    }
  }, {
    key: "createUserADAL",
    value: function createUserADAL(_ref3) {
      var upn = _ref3.upn,
        lastname = _ref3.lastname,
        firstname = _ref3.firstname,
        group = _ref3.group,
        modules = _ref3.modules,
        shops = _ref3.shops,
        language = _ref3.language,
        email = _ref3.email;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
    }
  }, {
    key: "deleteCatalog",
    value: function deleteCatalog(catalogCod) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: catalogCod
      };
      _NextApiClient.NextApiClient.com(this.service, 'DeleteCatalog', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteCompany",
    value: function deleteCompany(companyCod) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: companyCod
      };
      _NextApiClient.NextApiClient.com(this.service, 'DeleteCompany', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteOrganization",
    value: function deleteOrganization(organizationCod) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: organizationCod
      };
      _NextApiClient.NextApiClient.com(this.service, 'DeleteOrganization', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteShops",
    value: function deleteShops(shopCod) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: shopCod
      };
      _NextApiClient.NextApiClient.com(this.service, 'DeleteShops', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteUserADAL",
    value: function deleteUserADAL(userId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: userId
      };
      _NextApiClient.NextApiClient.com(this.service, 'DeleteUserADAL', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "deleteUsers",
    value: function deleteUsers(userId) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: userId
      };
      _NextApiClient.NextApiClient.com(this.service, 'DeleteUsers', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getUserADAL",
    value: function getUserADAL(upn) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: upn
      };
      _NextApiClient.NextApiClient.com(this.service, 'GetUserADAL', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "helperSearch",
    value: function helperSearch(_ref4) {
      var table = _ref4.table,
        _ref4$page = _ref4.page,
        page = _ref4$page === void 0 ? 1 : _ref4$page,
        _ref4$rows = _ref4.rows,
        rows = _ref4$rows === void 0 ? -1 : _ref4$rows,
        _ref4$order = _ref4.order,
        order = _ref4$order === void 0 ? 0 : _ref4$order,
        where = _ref4.where;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        Table: table,
        Page: page,
        Rows: rows,
        cOrder: order,
        cWhere: where
      };
      _NextApiClient.NextApiClient.com(this.service, 'HelperSearch', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getCatalog",
    value: function getCatalog(catCod) {
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        cod: catCod,
        dir: dir
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetCatalog', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getCompany",
    value: function getCompany() {}
  }, {
    key: "getOrganization",
    value: function getOrganization() {}
  }, {
    key: "getShops",
    value: function getShops(shopCod) {
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        cod: shopCod,
        dir: dir
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetShops', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getStdFileOrganization",
    value: function getStdFileOrganization() {}
  }, {
    key: "getUsers",
    value: function getUsers(userId) {
      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        cod: userId,
        dir: dir
      };
      _NextApiClient.NextApiClient.com(this.service, 'jGetUsers', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "loadTab",
    value: function loadTab(table) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        cod: table
      };
      _NextApiClient.NextApiClient.com(this.service, 'jLoadTab', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "saveCatalog",
    value: function saveCatalog(catData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(catData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jSaveCatalog', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "saveCompany",
    value: function saveCompany() {}
  }, {
    key: "saveOrganization",
    value: function saveOrganization() {}
  }, {
    key: "saveShop",
    value: function saveShop(shopData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(shopData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jSaveShops', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "saveStdFileOrganization",
    value: function saveStdFileOrganization() {}
  }, {
    key: "saveTab",
    value: function saveTab(table, data) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (j) {
        console.error(j);
      };
      var params = {
        cod: table,
        data: (0, _stringify["default"])(data)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jSaveTab', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "saveUser",
    value: function saveUser(userData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        data: (0, _stringify["default"])(userData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'jSaveUsers', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "getProfile",
    value: function getProfile() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.error(j);
      };
      _NextApiClient.NextApiClient.com(this.service, 'GetProfile', {}, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(userData) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (j) {
        console.log(j);
      };
      var cbErr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (j) {
        console.error(j);
      };
      var params = {
        userdata: (0, _stringify["default"])(userData)
      };
      _NextApiClient.NextApiClient.com(this.service, 'UpdateProfile', params, function (json) {
        if (cb) cb(json);
      }, function (err) {
        if (cbErr) cbErr(err);
      });
    }
  }]);
  return ErpAPI;
}();
exports.ErpAPI = ErpAPI;
ErpAPI.service = 'server2';
//# sourceMappingURL=ErpAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/ErpAPI.js
// module id = 1218
// module chunks = 142